module.exports = __webpack_public_path__ + "media/36_Long.094bc691.mp3";